import { preleverJetonLancement } from './entree'

/**
 * LE PRÉLÈVEMENT DU LAISSEZ-PASSER, AVANT TOUT LE RESTE.
 *
 * ─── Le défaut que ce module ferme ──────────────────────────────────────────
 *
 * `createWebHistory()` capture `window.location` — fragment compris — au moment
 * où le routeur est CRÉÉ, c'est-à-dire à l'import de `./router`. Nettoyer
 * l'adresse ensuite ne change plus rien : le routeur navigue vers celle qu'il a
 * mémorisée, et le `#lancement=…` réapparaît dans la barre d'adresse après
 * qu'on l'en a retiré.
 *
 * L'intention est à USAGE UNIQUE. Le fragment ainsi ressuscité survit au
 * signet, à l'historique, et surtout au premier F5 : le jeton est alors rejoué,
 * le moteur le refuse — à raison — et la page affiche « lancement refusé » à
 * quelqu'un dont la session est parfaitement valide.
 *
 * Mesuré en production par le banc de parcours, après la correction de l'ordre
 * de démarrage : l'application entrait bien, et gardait le jeton dans son URL.
 * Le backoffice porte le même module, pour la même raison.
 *
 * ─── Pourquoi PRÉLEVER seulement, et ne pas consommer ici ───────────────────
 *
 * La consommation est un aller-retour réseau ; l'import d'un module ne peut pas
 * l'attendre. On sépare donc les deux : la LECTURE de l'adresse, qui doit être
 * immédiate et synchrone parce qu'elle court contre la création du routeur, et
 * l'ÉCHANGE, qui reste dans `demarrer()`.
 *
 * Ce module n'a pas d'API à appeler au bon moment : importer `./entree` suffit
 * à le déclencher. C'est voulu — une fonction à appeler serait une fonction
 * qu'on oublie d'appeler assez tôt.
 */

/** Le jeton retiré de l'adresse, ou `null` : il n'y en avait pas. */
let jeton: string | null = null
let fait = false

/**
 * Le jeton de lancement de CE chargement de page.
 *
 * Idempotent : l'adresse n'est lue qu'une fois. Un second appel rend le même
 * jeton plutôt que `null` — sans quoi le prélèvement précoce priverait
 * l'échange de ce qu'il vient de retirer.
 */
export function jetonDeLancement(): string | null {
  if (!fait) {
    fait = true
    jeton = preleverJetonLancement()
  }
  return jeton
}

// À l'ÉVALUATION du module, pas sur appel : c'est la seule façon d'être devant
// la création du routeur, qui n'attend personne.
jetonDeLancement()
